import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';

const BENDA_URL = process.env.REACT_APP_BENDA_URL || 'http://localhost:3004';

const DashboardLayout = () => {
  return (
    <div className="flex h-screen hrms-shell">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <Header />
        <main className="flex-1 overflow-y-auto hrms-main p-4 sm:p-6">
          <Outlet />
        </main>
        <footer className="shrink-0 border-t border-slate-200/70 bg-white/80 px-4 py-3 text-center text-[11px] font-medium text-slate-400 sm:px-6">
          <span>
            © {new Date().getFullYear()} People Desk • Powered by{' '}
            <a
              href={BENDA_URL}
              target="_blank"
              rel="noreferrer"
              className="text-slate-500 transition-colors hover:text-slate-700"
            >
              Benda Infotech
            </a>
            .
          </span>
        </footer>
      </div>
    </div>
  );
};

export default DashboardLayout;
